import Color from 'color';

import airboTheme from '../../themes/airbo';

const LIGHT_TEXT = airboTheme.colors.white;
const DARK_TEXT = airboTheme.colors.black[100];

/**
 * The text color to put on a background an admin picked, such as a campaign's
 * color: white or the theme's near-black, whichever contrasts more.
 *
 * @param {string} background Any CSS color the `color` package parses.
 * @returns {string} White when the background can't be parsed.
 */
export const readableTextColor = background => {
  let color;
  try {
    color = Color(background);
  } catch {
    return LIGHT_TEXT;
  }

  return color.contrast(Color(DARK_TEXT)) > color.contrast(Color(LIGHT_TEXT))
    ? DARK_TEXT
    : LIGHT_TEXT;
};
